import { WeatherData } from '@energybox/react-ui-library/dist/types';
import assoc from 'ramda/src/assoc';
import assocPath from 'ramda/src/assocPath';
import pipe from 'ramda/src/pipe';
import { Actions } from '../actions/weather';

export type Weather = {
  weatherBySiteId: WeatherBySiteId;
  isLoading: boolean;
};

export type WeatherBySiteId = {
  [siteId: string]: WeatherData;
};

const initialState = {
  weatherBySiteId: {},
  isLoading: false
};

const normalizeWeatherResponse = (apiResponse: any) => ({
  siteId: apiResponse.id,
  humidity: apiResponse.humidity,
  temperature: apiResponse.temperature,
  timestamp: apiResponse.timestamp,
  windchill: apiResponse.windchill
});

const weather = (state: Weather = initialState, action: any) => {
  switch (action.type) {
    case Actions.GET_WEATHER_BY_SITE_ID_SUCCESS:
      return pipe(
        assocPath(
          ['weatherBySiteId', action.siteId],
          normalizeWeatherResponse(action.data)
        ),
        assoc('isLoading', false)
      )(state);

    case Actions.GET_WEATHER_BY_SITE_ID_ERROR:
      return assoc('isLoading', false, state);

    case Actions.GET_WEATHER_BY_SITE_ID_LOADING:
      return assoc('isLoading', true, state);

    default:
      return state;
  }
};

export default weather;
